import { render, staticRenderFns } from "./ChannelsSvg.vue?vue&type=template&id=22718f74&scoped=true"
import script from "./ChannelsSvg.vue?vue&type=script&lang=js"
export * from "./ChannelsSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22718f74",
  null
  
)

export default component.exports